import { createSelector } from '@reduxjs/toolkit';
import { selectActionsForDevice } from './actionsSlice';
import { findEntity, selectEntitiesForDevice } from './entitiesSlice';
import { selectDevice } from '../features/devices/devicesSlice';
export const selectWidgetForDevice = createSelector([selectActionsForDevice, selectEntitiesForDevice, selectDevice], (deviceActions, deviceEntities, device) => {
    const onoffEntity = findEntity(deviceEntities, 'onoff');
    const onoffunknownEntity = findEntity(deviceEntities, 'onoff?');
    const onoffAction = findEntity(deviceActions, 'onoff');
    const levelEntity = findEntity(deviceEntities, 'level');
    const levelAction = findEntity(deviceActions, 'level');
    const colorTemperatureEntity = findEntity(deviceEntities, 'color_temperature');
    const colorTemperatureAction = findEntity(deviceActions, 'color_temperature');
    const hasOnOff = onoffEntity !== undefined && onoffAction !== undefined;
    const hasOnOffUnknown = onoffunknownEntity !== undefined && onoffAction !== undefined;
    const hasLevel = levelEntity !== undefined && levelAction !== undefined;
    const hasColorTemperature = colorTemperatureEntity !== undefined && colorTemperatureAction !== undefined;
    const shadesEntity = findEntity(deviceEntities, 'shades?');
    const shadesAction = findEntity(deviceActions, 'shades');
    const hasShades = shadesEntity !== undefined && shadesAction !== undefined;
    const temperatureEntity = findEntity(deviceEntities, 'temperature');
    const humidityEntity = findEntity(deviceEntities, 'humidity');
    const isThermometer = temperatureEntity !== undefined;
    if (device == undefined) {
        return undefined;
    }
    if (device.protocol.name == 'nexa transmitter' && levelAction !== undefined && hasOnOffUnknown && !hasLevel && !hasColorTemperature) {
        // special case Nexa Dimmers that has a 0-100 level action but no level entity
        return { kind: 'NexaDimmer', entity: onoffunknownEntity, actionOnOff: onoffAction, actionLevel: levelAction };
    }
    else if (hasOnOff || hasLevel || hasColorTemperature) {
        return {
            kind: 'Light',
            onoff: hasOnOff ? { entity: onoffEntity, action: onoffAction } : undefined,
            level: hasLevel ? { entity: levelEntity, action: levelAction } : undefined,
            colorTemperature: hasColorTemperature ? { entity: colorTemperatureEntity, action: colorTemperatureAction } : undefined,
        };
    }
    else if (hasOnOffUnknown) {
        return {
            kind: 'OnOffUnknown',
            entity: onoffunknownEntity,
            action: onoffAction
        };
    }
    else if (hasShades) {
        return {
            kind: 'Shades',
            entity: shadesEntity,
            action: shadesAction
        };
    }
    else if (isThermometer) {
        return {
            kind: 'Thermometer',
            temp: temperatureEntity,
            humid: humidityEntity,
        };
    }
    else {
        return undefined;
    }
});
